import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, Phone, MapPin, Send, Facebook, Twitter, Linkedin, Instagram, CheckCircle } from 'lucide-react';

const Contact = () => {
    const [formStatus, setFormStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormStatus('submitting');

        const formData = new FormData(e.target);

        try {
            const response = await fetch("https://formsubmit.co/ajax/info.aadharinfotech7@gmail.com", {
                method: "POST",
                body: formData
            });

            if (response.ok) {
                setFormStatus('success');
                e.target.reset();
            } else {
                setFormStatus('error');
            }
        } catch (error) {
            setFormStatus('error');
        }
    };
    return (
        <div className="contact-container">
            <section className="contact-hero">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="section-header"
                    >
                        <h1 className="section-title">Get In Touch</h1>
                        <p className="section-subtitle">Have a project in mind? We'd love to hear from you.</p>
                    </motion.div>

                    <div className="contact-main-grid">
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            className="contact-info-panel"
                        >
                            <div className="info-card-premium glass-morphism">
                                <h2>Contact Information</h2>
                                <p className="p-muted">Fill out the form and our team will get back to you within 24 hours.</p>

                                <div className="contact-details-list">
                                    <div className="contact-detail-item">
                                        <div className="icon-wrapper-circle"><Phone size={22} /></div>
                                        <div className="detail-text">
                                            <span className="label-top">Call Us Now</span>
                                            <p className="actual-val">+91 8218629011</p>
                                        </div>
                                    </div>
                                    <div className="contact-detail-item">
                                        <div className="icon-wrapper-circle"><Mail size={22} /></div>
                                        <div className="detail-text">
                                            <span className="label-top">Official Email</span>
                                            <p className="actual-val">info.aadharinfotech7@gmail.com</p>
                                        </div>
                                    </div>
                                    <div className="contact-detail-item">
                                        <div className="icon-wrapper-circle"><MapPin size={22} /></div>
                                        <div className="detail-text">
                                            <span className="label-top">Headquarters</span>
                                            <p className="actual-val">Lucknow, Uttar Pradesh, India</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="social-links-container">
                                    <button className="social-icon-btn"><Facebook size={20} /></button>
                                    <button className="social-icon-btn"><Twitter size={20} /></button>
                                    <button className="social-icon-btn"><Linkedin size={20} /></button>
                                    <button className="social-icon-btn"><Instagram size={20} /></button>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            className="contact-form-panel"
                        >
                            <AnimatePresence mode="wait">
                                {formStatus === 'success' ? (
                                    <motion.div
                                        key="success"
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        exit={{ opacity: 0, scale: 0.9 }}
                                        className="success-message-panel glass-morphism"
                                    >
                                        <div className="success-icon-wrapper">
                                            <CheckCircle size={60} color="var(--primary)" />
                                        </div>
                                        <h3>Message Sent!</h3>
                                        <p>Thank you for reaching out. Our team will get back to you within 24 hours.</p>
                                        <button
                                            onClick={() => setFormStatus('idle')}
                                            className="btn btn-primary"
                                            style={{ marginTop: '2rem' }}
                                        >
                                            Send Another Message
                                        </button>
                                    </motion.div>
                                ) : (
                                    <motion.form
                                        key="form"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        onSubmit={handleSubmit}
                                        className="premium-form glass-morphism"
                                    >
                                        <div className="form-grid-row">
                                            <div className="input-field">
                                                <label>First Name</label>
                                                <input type="text" name="First Name" placeholder="John" required />
                                            </div>
                                            <div className="input-field">
                                                <label>Last Name</label>
                                                <input type="text" name="Last Name" placeholder="Doe" required />
                                            </div>
                                        </div>
                                        <div className="input-field">
                                            <label>Email Address</label>
                                            <input type="email" name="email" placeholder="john@example.com" required />
                                        </div>
                                        <div className="input-field">
                                            <label>Select Service</label>
                                            <select name="Service" required>
                                                <option value="Web Development">Web Development</option>
                                                <option value="Mobile App Dev">Mobile App Dev</option>
                                                <option value="Digital Strategy">Digital Strategy</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                        <div className="input-field">
                                            <label>Your Message</label>
                                            <textarea name="Message" rows="5" placeholder="Tell us about your project..." required></textarea>
                                        </div>
                                        <button
                                            type="submit"
                                            disabled={formStatus === 'submitting'}
                                            className="btn btn-primary form-submit-btn"
                                        >
                                            {formStatus === 'submitting' ? 'Sending...' : 'Send Message'}
                                            <Send size={20} className="send-icon" />
                                        </button>
                                        {formStatus === 'error' && (
                                            <p className="error-message">Something went wrong. Please try again.</p>
                                        )}
                                    </motion.form>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    </div>
                </div>
            </section>

            <style>{`
        .contact-container { padding-top: 100px; }
        .contact-hero { padding: 80px 0; }
        .section-header { text-align: center; margin-bottom: 6rem; }
        .section-title { font-size: 3.5rem; font-weight: 800; margin-bottom: 1.5rem; }
        
        .contact-main-grid { display: grid; grid-template-columns: 0.8fr 1.2fr; gap: 4rem; margin-top: 2rem; }
        
        .info-card-premium { padding: 4.5rem; border-radius: 3.5rem; background: linear-gradient(135deg, var(--secondary), var(--primary)); color: #000; border: none; height: 100%; display: flex; flex-direction: column; overflow: hidden; position: relative; }
        .info-card-premium::after { content: ''; position: absolute; top: -50px; right: -50px; width: 150px; height: 150px; background: rgba(255,255,255,0.1); border-radius: 50%; }
        
        .info-card-premium h2 { font-size: 2.5rem; font-weight: 800; margin-bottom: 1.2rem; line-height: 1.1; }
        .p-muted { margin-bottom: 4rem; font-weight: 600; opacity: 0.8; font-size: 1.1rem; }
        
        .contact-details-list { display: flex; flex-direction: column; gap: 3rem; flex-grow: 1; }
        .contact-detail-item { display: flex; align-items: center; gap: 1.8rem; }
        .icon-wrapper-circle { width: 55px; height: 55px; background: rgba(0,0,0,0.1); border-radius: 1.25rem; display: flex; align-items: center; justify-content: center; }
        .label-top { display: block; font-size: 0.85rem; font-weight: 800; opacity: 0.6; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 0.3rem; }
        .actual-val { font-size: 1.2rem; font-weight: 700; }
        
        .social-links-container { display: flex; gap: 1.2rem; margin-top: 5rem; }
        .social-icon-btn { width: 48px; height: 48px; border-radius: 14px; background: rgba(0,0,0,0.1); display: flex; align-items: center; justify-content: center; color: #000; transition: var(--transition); }
        .social-icon-btn:hover { background: #000; color: #fff; transform: translateY(-5px); }
        
        .premium-form { padding: 4.5rem; border-radius: 3.5rem; border: 1px solid var(--border-glass); background: rgba(255, 255, 255, 0.02); }
        .form-grid-row { display: grid; grid-template-columns: 1fr 1fr; gap: 2.5rem; }
        .input-field { margin-bottom: 2.5rem; display: flex; flex-direction: column; gap: 0.8rem; }
        .input-field label { font-size: 0.95rem; font-weight: 700; color: #fff; margin-left: 0.5rem; }
        .input-field input, .input-field select, .input-field textarea { padding: 1.2rem 1.5rem; border-radius: 1.25rem; background: rgba(255, 255, 255, 0.05); border: 1px solid var(--border-glass); color: #fff; font-size: 1.05rem; transition: var(--transition); width: 100%; }
        .input-field input:focus, .input-field select:focus, .input-field textarea:focus { outline: none; border-color: var(--primary); background: rgba(255, 255, 255, 0.08); box-shadow: 0 0 20px rgba(0, 242, 255, 0.1); }
        
        .form-submit-btn { padding: 1.3rem; border-radius: 1.25rem; font-weight: 800; font-size: 1.15rem; margin-top: 1rem; width: 100%; justify-content: center; transition: var(--transition); }
        .form-submit-btn:disabled { opacity: 0.7; cursor: not-allowed; }
        .form-submit-btn:hover .send-icon { transform: translate(5px, -5px) rotate(-10deg); }

        .success-message-panel { text-align: center; padding: 6rem 4.5rem; border-radius: 3.5rem; border: 1px solid var(--border-glass); background: rgba(255, 255, 255, 0.02); display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; }
        .success-icon-wrapper { margin-bottom: 2rem; }
        .success-message-panel h3 { font-size: 2.5rem; font-weight: 800; color: #fff; margin-bottom: 1rem; }
        .success-message-panel p { font-size: 1.2rem; color: var(--text-muted); max-width: 400px; }
        .error-message { color: #ff4d4d; margin-top: 1rem; text-align: center; font-weight: 600; }

        @media (max-width: 1100px) {
          .contact-main-grid { grid-template-columns: 1fr; }
          .info-card-premium { padding: 3.5rem; height: auto; }
        }

        @media (max-width: 768px) {
          .contact-hero { padding: 60px 0; }
          .section-title { font-size: 2.8rem; }
          .info-card-premium { padding: 2.5rem 1.5rem; border-radius: 2.5rem; }
          .info-card-premium h2 { font-size: 2rem; }
          .p-muted { margin-bottom: 2.5rem; font-size: 1rem; }
          .contact-details-list { gap: 2rem; }
          .actual-val { font-size: 1rem; }
          .social-links-container { margin-top: 3.5rem; justify-content: center; }
          
          .premium-form { padding: 2.5rem 1.5rem; border-radius: 2.5rem; }
          .form-grid-row { grid-template-columns: 1fr; gap: 0; }
        }
      `}</style>
        </div>
    );
};

export default Contact;
